import {
  $albumsTableFilters,
  $albumsTablePage,
  $albumsTablePageSize,
  $albumsTableSearch,
  $albumsTableSort,
  type AlbumsSortState,
  albumsTableQuery,
  albumsTableSearchReset,
} from '@/entities/albums'
import type { GetApiAlbumsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { combine, createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const CollectionsListPageGate = createGate()

// Altering

const $filterTypes = $albumsTableFilters.map((filters) => filters.Types || null)

sample({
  source: combine({
    queryStatus: albumsTableQuery.$status,
    gateStatus: CollectionsListPageGate.status,
  }),
  clock: $filterTypes,
  filter: ({ queryStatus, gateStatus }) =>
    queryStatus !== 'initial' && gateStatus,
  target: albumsTableSearchReset,
})

// Last state

// Filters
export const $collectionsListPageLatestAlbumsFilters =
  createStore<GetApiAlbumsQueryParams>({})
sample({
  source: $albumsTableFilters,
  clock: CollectionsListPageGate.close,
  target: $collectionsListPageLatestAlbumsFilters,
})
// Sort
export const $collectionsListPageLatestAlbumsSort =
  createStore<AlbumsSortState>({
    field: null,
    order: null,
  })
sample({
  source: $albumsTableSort,
  clock: CollectionsListPageGate.close,
  target: $collectionsListPageLatestAlbumsSort,
})

// Page
export const $collectionsListPageLatestAlbumsPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $albumsTablePage,
  clock: CollectionsListPageGate.close,
  target: $collectionsListPageLatestAlbumsPage,
})

// Page size
export const $collectionsListPageLatestAlbumsPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  source: $albumsTablePageSize,
  clock: CollectionsListPageGate.close,
  target: $collectionsListPageLatestAlbumsPageSize,
})

// Search
export const $collectionsListPageLatestAlbumsSearch = createStore<string>('')
sample({
  source: $albumsTableSearch,
  clock: CollectionsListPageGate.close,
  fn: (search) => search || '',
  target: $collectionsListPageLatestAlbumsSearch,
})
